import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/drives`;

export const fetchDrivesApi = async (collectionId) => {
  const response = await axios.post(API_BASE_URL, {
    collectionID: collectionId,
  });
  return response;
};

export const fetchDrivesByCompanyApi = async (companyid) => {
  const response = await axios.post(API_BASE_URL, {
    companyID: companyid,
  });
  return response;
};

export const fetchDriveStorageUrl = async (driveId) => {
  const response = await axios.get(`${API_BASE_URL}/storage-url/${driveId}`);
  return response;
};

export const reprocessDriveApi = async (driveid) => {
  const response = await axios.post('http://35.222.74.57/api/v1/drive/retry_drive_processing', {
    drive_id: driveid,
  });
  return response;
};

export const driveDeleteApi = async (driveid) => {
  const response = await axios.get(`${API_BASE_URL}/delete/${driveid}`);
  return response;
};

export const getCollectionDrivesApi = async (collectionId) => {
  const response = await axios.get(`${API_BASE_URL}/${collectionId}/drives`);
  return response;
};

export const fetchDrives = async (companyid) => {
  const response = await axios.post(`${API_BASE_URL}/drive-manage`, {
    companyID: companyid,
  });
  return response;
};

export const fetchDrivesStateApi = async (stateName) => {
  const response = await axios.get(`${API_BASE_URL}/state/${stateName}`);
  return response;
};
